<div
  class="page-container"
  [ngStyle]="{
    '--color50': category.color50,
    '--color0': category.color0,
    '--color70': category.color70,
    '--color80': category.color80,
    '--color90': category.color90,
  }">
  <div class="header background-transparent">
    <span class="font-bold-display-medium title-color">
      Zahlungsmethode auswählen
    </span>
    <span class="font-regular-title-large font-color-black">
      Bitte wähle deine präferierte Zahlungsmethode.
      @if (paypalEnabled) {
        Bei Paypal wirst Du auf die Seite des Anbieters weitergeleitet
      }
    </span>
  </div>
  <div class="payment-methods">
    <div class="button" (click)="selectPaymentMethod('invoice')">
      <i class="fa-regular fa-credit-card"></i>
      <span class="font-medium-title-medium">Überweisung</span>
    </div>
    @if (paypalEnabled) {
      <div id="paypal-button-container"></div>
    }
  </div>
  <div class="flex-r flex-1-1-0 justify-center"></div>
</div>
